import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import { Trans, useTranslation } from 'react-i18next';

import { NoResultsFoundIcon } from '@/assets/icons/NoResultsFoundIcon';

import { autocompleteDropdownNoOptionsStyles as sx } from './AutocompleteDropdownNoOptions.styles';

type Props = {
	query: string;
};

export const AutocompleteDropdownNoOptions = ({ query }: Props) => {
	const { t } = useTranslation();

	return (
		<Box sx={sx.root}>
			<NoResultsFoundIcon sx={sx.searchIcon} />

			<Box sx={sx.description}>
				<Box sx={sx.text} color='text.secondary'>
					<Trans
						defaults='No results for <bold>{{query}}</bold>.'
						values={{ query: query }}
						components={{
							bold: (
								<Typography
									sx={sx.query}
									variant='body1'
									color='text.fadedPrimary'
									fontWeight={700}
									maxWidth={50}
								/>
							)
						}}
					/>
				</Box>

				<Box sx={sx.text} color='text.secondary'>
					{t('Try a different search term.')}
				</Box>
			</Box>
		</Box>
	);
};
